import { API_PREFIX } from '@diario/common';
import { type } from 'arktype';

/**
 * Entorno del navegador, validado al cargar la aplicación (ADR-0013).
 * Solo variables `VITE_*`: son las únicas que Vite inlinea en el bundle y, por tanto,
 * las únicas públicas. Ningún secreto vive aquí — Supabase es exclusivamente server-side.
 */
const envSchema = type({ VITE_API_URL: 'string >= 1' });

const resultado = envSchema({
	// El prefijo del contrato compartido es el valor correcto por defecto: en desarrollo lo
	// proxya Vite y en producción, Nginx. Solo hace falta definirlo si la API vive en otro origen.
	VITE_API_URL: import.meta.env.VITE_API_URL ?? API_PREFIX,
});

if (resultado instanceof type.errors) {
	throw new Error(`Configuración de entorno inválida:\n${resultado.summary}`);
}

export const env = resultado;
